import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import layout from "@/layout/index.vue";
import ReleaseData from "@/views/ReleaseData.vue";
import NovelData from "@/views/NovelData.vue";
import Login from "@/views/Login.vue";
import AppList from "@/views/AppList.vue";
import UserList from "@/views/UserList.vue";
import AccountList from "@/views/AccountList.vue";
import PayList from "@/views/PayList.vue";
import DelList from "@/views/DelList.vue";
import AgentList from "@/views/AgentList.vue";
import ContactList from "@/views/ContactList.vue";
import WorkList from "@/views/WorkList.vue";
import MenuList from "@/views/MenuManage/MenuList.vue";
import RoleManage from "@/views/RoleManage.vue";
import PermissionTest from "@/views/PermissionTest.vue";
import BmManage from "@/views/BmManage.vue";
import Addata from "@/views/Addata.vue";
import Backlog from "@/views/Backlog.vue";
import NoticeList from "@/views/Noticelist/index.vue";
import WalletList from "@/views/Walletlist/index.vue";
import Home from "@/views/Home.vue";
import Expend from "@/views/expend.vue";
import Recycle from "@/views/recycle.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login",
    children: [
      {
        path: "/login",
        component: Login,
      },
    ],
  },
  {
    path: "/user",
    name: "layout",
    component: layout,
    redirect: "/user",
    children: [
      {
        path: "/home",
        component: Home,
      },
      {
        path: "/user",
        component: UserList,
      },
      {
        path: "/accounts",
        component: AccountList,
      },
      {
        path: "/dellist",
        component: DelList,
      },
      {
        path: "/paylist",
        component: PayList,
      },
      {
        path: "/agentlist",
        component: AgentList,
      },
      {
        path: "/contactlist",
        component: ContactList,
      },
      {
        path: "/worklist",
        component: WorkList,
      },
      {
        path: "/bm",
        component: BmManage,
      },
      {
        path: "/rolelist",
        component: RoleManage,
      },
      {
        path: "/RoleManage",
        component: RoleManage,
      },
      {
        path: "/permission-test",
        component: PermissionTest,
      },
      {
        path: "/addata",
        component: Addata,
      },
      {
        path: "/backlog",
        component: Backlog,
      },
      {
        path: "/noticelist",
        component: NoticeList,
      },
      {
        path: "/walletlist",
        component: WalletList,
      },
      {
        path: "/expend",
        component: Expend,
      },
      {
        path: "/recycle",
        component: Recycle,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
